import {useEffect,useState } from "react";
import {Header} from "./components/Header";
import {AddTask} from "./components/AddTask";
import {ShowTask} from "./components/ShowTask";
import {ExportButtons} from "./components/ExportButtons";
import './App.css';


function App() {
  const [tasklist, setTasklist] = useState(JSON.parse(localStorage.getItem("tasklist"))|| []);
  const [task,setTask] =useState({});

  useEffect(()=> {
    localStorage.setItem("tasklist",JSON.stringify(tasklist))
  },[tasklist]);
  
  // Notifications: check deadlines periodically and notify 5 minutes before
  useEffect(()=>{
    if(!('Notification' in window)) return;
    if(Notification.permission !== 'granted') Notification.requestPermission();
    const check = ()=>{
      const now = Date.now();
      tasklist.forEach(t=>{
        if(!t.deadline) return;
        if(t.notified) return;
        const d = new Date(t.deadline).getTime();
        const diff = d - now;
        if(diff > 0 && diff <= 5*60*1000){
          if(Notification.permission === 'granted'){
            new Notification('Task deadline soon', {body: `${t.name} in ${Math.ceil(diff/60000)} minutes`});
          }
          // mark notified
          setTasklist(prev => prev.map(x => x.id===t.id ? {...x, notified:true} : x));
        }
      })
    }
    const id = setInterval(check,30*1000);
    // run once now too
    check();
    return ()=> clearInterval(id);
  },[tasklist,setTasklist]);
  
  
  return (
    <div className="App">
     <Header />
     <div style={{display:'flex',justifyContent:'flex-end',padding:'8px'}}>
       <ExportButtons tasklist={tasklist} />
     </div>
     <AddTask 
     tasklist={tasklist} 
     setTasklist={setTasklist}
      task={task}
      setTask={setTask}
     />
     <ShowTask 
     tasklist={tasklist} 
     setTasklist={setTasklist}
     task={task}
     setTask={setTask}
     />
    </div>
  );
}
export default App;
